"use strict";
const angular = require("angular");

const uiRouter = require("angular-ui-router");

import routes from "./incident.routes";
import _ from "lodash";
import headerComponent from "../../components/header/header.component";

export class IncidentComponent {
  dateOptions = {
    maxDate: new Date(),
    minDate: new Date(1900, 1, 1),
    startingDay: 1
  };
  shared = false;
  sections = [
    {
      id: "locationDetails",
      name: "Location Details"
    },
    {
      id: "incidentDetails",
      name: "Incident Details"
    },
    {
      id: "avalancheDetails",
      name: "Avalanche Details",
      typeRequired: "Skiing - Avalanche"
    },
    {
      id: "snowImmersionDetails",
      name: "Snow Immersion Details",
      typeRequired: "Skiing - Snow Immersion"
    },
    {
      id: "collisionDetails",
      name: "Collision Details",
      typeRequired: "Collision"
    },
    {
      id: "skiAccidentDetails",
      name: "Skiing Details",
      typeRequired: "Skiing - General"
    },
    {
      id: "crevasseDetails",
      name: "Crevasse Details",
      typeRequired: "Skiing - Crevasse"
    },
    {
      id: "helicopterDetails",
      name: "Helicopter Details",
      typeRequired: "Helicopter"
    },
    {
      id: "vehicleDetails",
      name: "Vehicle Details",
      typeRequired: "Motor Vehicle"
    },
    {
      id: "snowcatDetails",
      name: "Snowcat Details",
      typeRequired: "Snowcat"
    },
    {
      id: "snowmobileDetails",
      name: "Snowmobile Details",
      typeRequired: "Snowmobile"
    },
    {
      id: "conditions",
      name: "Condition Details",
      typeRequired:
        "Skiing - Avalanche,Skiing - Crevasse,Skiing - Snow Immersion,Skiing - General,\
      Hiking/Mountaineering - General,Mountain Biking - General,Helicopter,\
      Snowcat,Snowmobile,Motor Vehicle,Medical Condition & Illness,Other"
    },
    {
      id: "patientDetails",
      name: "Patient Details"
    },

    {
      id: "attachments",
      name: "Attachments"
    },
    {
      id: "sharing",
      name: "Sharing"
    },
    {
      id: "notes",
      name: "Admin/Notes"
    }
    // {
    //   id: "response",
    //   name: "Response Details"
    // }
  ];
  selectedSection;

  popover(attachment) {
    console.log("popover", attachment);
    return `<img class="img-responsive" src="/api/incidents/attachment/${attachment.id}">`;
  }

  updateDateTime() {
    if (this.datetime) {
      if (this.timehours && this.timemins) {
        this.incident.time = this.timehours + ":" + this.timemins;
      }

      if (this.incident.time) {
        let item = this.incident.time.split(":");
        let hours = item[0];
        let minutes = item[1];

        this.datetime.setHours(hours);
        this.datetime.setMinutes(minutes);
      }

      this.incident.datetime = this.datetime;
    }
  }

  /*@ngInject*/
  constructor(
    $stateParams,
    appConfig,
    $http,
    ngToast,
    moment,
    $uibModal,
    $rootScope,
    Auth,
    $state
  ) {
    "ngInject";

    this.constants = appConfig;
    this.$http = $http;
    this.ngToast = ngToast;
    this.$uibModal = $uibModal;
    this.$rootScope = $rootScope;
    this.$state = $state;

    if (Auth.isOpAdmin) {
      Auth.isOpAdmin().then(opAdmin => {
        this.isOpAdmin = opAdmin;
      });
    }
    this.selectedSection = this.sections[0].id;

    if (!$stateParams.id) {
      console.log("must have id...");
    }

    $http
      .get(`/api/incidents/${$stateParams.id}`)
      .then(result => {
        console.log("result is: ", result);
        if (!result.data.id) {
          //Could not find in DB.
          this.$state.go("dashboard");
          this.ngToast.create({
            className: "danger",
            content: "Unable to find that Incident."
          });

          return;
        }

        this.incident = result.data;

        if (this.incident.time) {
          this.timehours = this.incident.time.substring(0, 2);
          this.timemins = this.incident.time.substring(3, 5);
        }

        if (this.incident.datetime) {
          this.datetime = moment(this.incident.datetime).toDate();
        } else if (this.incident.date) {
          this.datetime = moment(this.incident.datetime, "YYYY-MM-DD").toDate();
        }

        this.updateSharedStatus();
        console.log("this.datetime:", this.datetime);

        if (this.incident.Patients) {
          _.forEach(this.incident.Patients, patient => {
            console.log("on patient: ", patient);
            if (patient.complaintInjury) {
              patient.complaintInjury = patient.complaintInjury.split(",");
            }
            if (patient.assessedInjury) {
              patient.assessedInjury = patient.assessedInjury.split(",");
            }
          });
        }
        this.originalIncident = _.cloneDeep(this.incident);
      })
      .catch(error => {
        console.log("error:", error);
      });

    this.incident = $stateParams.incident;

    // if(this.incident == null) {
    //   this.incident = {
    //     incidentType: 'Avalanche',
    //     title: 'Jackson Valley, Skier Tiggered near miss',
    //     date: '2018-03-18',
    //     time: '15:30',
    //     severity: 'Close Call',
    //     patients: [
    //       {
    //         name: 'Joe',
    //         type: 'Guest'
    //       }
    //     ],
    //     injurySummary: {}
    //   };
    // }
  }

  checkSave() {
    console.log("check save here");

    var bdiff = (a, b) =>
      _.reduce(
        a,
        (res, val, key) =>
          res.concat(
            (_.isPlainObject(val) || _.isArray(val)) && b
              ? bdiff(val, b[key]).map(x => key + "." + x)
              : !b || val != b[key]
              ? [key]
              : []
          ),
        []
      );

    //remove $$hashkey
    const incident = JSON.parse(angular.toJson(this.incident));
    var diff = bdiff(incident, this.originalIncident);
    if (diff.length > 0) {
      var modalScope = this.$rootScope.$new();
      modalScope.$uibModalInstance = this.$uibModal.open({
        animation: false,
        template: require("./confirmSave.html"),
        scope: modalScope
      });

      modalScope.$uibModalInstance.result.then(
        save => {
          this.saveIncident().then(() => {
            this.$state.go("dashboard");
          });
        },
        dismiss => {
          this.$state.go("dashboard");
        }
      );
    } else {
      this.$state.go("dashboard");
    }
  }

  updateSharedStatus() {
    this.shared =
      this.incident &&
      this.incident.privacyLevel &&
      this.incident.privacyLevel == "Shared";
  }

  changeSection(id) {
    this.selectedSection = id;
  }

  saveIncident() {
    // window.alert('Work in progress, will save here...');
    console.log("saving...");
    return this.$http
      .put(`/api/incidents/${this.incident.id}`, this.incident)
      .then(() => {
        // this.ngToast.create({content: "Saved.", dismissOnTimeout: false});
        this.ngToast.create("Incident has been updated.");
        this.updateSharedStatus();
        this.originalIncident = _.cloneDeep(this.incident);
      });
  }

  printIncident() {
    this.saveIncident().then(() => {
      let win = window.open(`/api/incidents/${this.incident.id}/print`);
      win.focus();
      win.print();
    });
  }

  getImageBanner() {
    if (!this.incident) {
      return;
    }
    let image;

    //request to remove this feature
    // if (this.incident.Attachments && this.incident.Attachments[0]) {
    //   image = `/api/incidents/attachment/${this.incident.Attachments[0].id}`;
    // }

    if (!image && !this.incident.incidentType) {
      return;
    }

    if (!image) {
      //use full paths so minification process can replace with revisioned image
      console.log("incidentType:", this.incident.incidentType);
      switch (this.incident.incidentType) {
        case "Skiing - Snow Immersion":
          image = "/assets/images/SkiingDefault.jpeg";
          break;
        case "Skiing - General":
          image = "/assets/images/SkiingDefault.jpeg";
          break;
        case "Hiking/Mountaineering - General":
          image = "/assets/images/SummerDefault.jpeg";
          break;
        case "Mountain Biking - General":
          image = "/assets/images/MountainBiking.jpeg";
          break;
        case "Helicopter":
          image = "/assets/images/Helicopter.jpeg";
          break;
        case "Snowcat":
          image = "/assets/images/Snowcat.jpeg";
          break;
        case "Snowmobile":
          image = "/assets/images/Snowmobile.jpeg";
          break;
        default:
          image = "/assets/images/WinterDefault.jpeg";
          break;
      }
    }

    var style = {
      "background-image": `url('${image}')`
    };

    return style;
  }

  deleteIncident() {
    console.log("launch Modal to confirm delete...");

    var modalScope = this.$rootScope.$new();
    // angular.extend(modalScope, {this.incident});

    modalScope.$uibModalInstance = this.$uibModal.open({
      animation: false,
      template: require("./deleteIncident.html"),
      scope: modalScope
    });

    modalScope.$uibModalInstance.result.then(() => {
      console.log("delete: ", this.incident.id);
      this.$http.delete(`/api/incidents/${this.incident.id}`).then(
        () => {
          this.$state.go("dashboard");
          this.ngToast.create({
            className: "success",
            content: "Incident has been removed."
          });
        },
        error => {
          this.ngToast.create({
            className: "danger",
            content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
          });
          console.log(error);
        }
      );
    });
  }
}

export default angular
  .module("hccApp.incident", [uiRouter])
  .config(routes)
  .component("incident", {
    template: require("./incident.html"),
    controller: IncidentComponent
  }).name;



// WEBPACK FOOTER //
// ./client/app/incident/incident.component.js